import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-subscribe-popup',
  templateUrl: './subscribe-popup.component.html',
  styleUrls: ['./subscribe-popup.component.scss'],
})
export class SubscribePopupComponent {
  subscribeForm: FormGroup;
  loginUser: any;
  showImage: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SubscribePopupComponent>,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private ngxLoader: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.subscribeForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
        ],
      ],
    });
  }
  ngOnInit(): void {
    this.loginUser = localStorage.getItem('username');
    if (
      this.loginUser === 'Zeronorth ZN' &&
      this.data.item.label === 'Port Consumption'
    ) {
      this.dialogRef.updateSize('735px', '470px');
      setTimeout(() => {
        this.showImage = true;
        this.dialogRef.updateSize('430px', '407px');
      }, 5000);
    }  else {
      this.showImage = true;
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.ngxLoader.start();
    if (this.subscribeForm.valid) {
      const emailValue = this.subscribeForm.value.email;
      console.log('Email submitted:', emailValue);

      const serviceID = 'service_k6lsf0e';
      const templateID = 'template_mp2uran';
      const userID = 'LHZ50IRmmSbvX2dRz';
      const name = this.loginUser;

      const templateParams = {
        from_name: name,
        from: emailValue,
      };

      emailjs.send(serviceID, templateID, templateParams, userID).then(
        (response: EmailJSResponseStatus) => {
          this.toastr.success('Email sent successfully!');
          console.log(
            'Email sent successfully!',
            response.status,
            response.text
          );
          this.dialogRef.close();
          this.ngxLoader.stop();
        },
        (error: any) => {
          console.error('Failed to send email.', error);
          this.ngxLoader.stop();
        }
      );
    }
  }

  get email() {
    return this.subscribeForm.get('email');
  }
}
